export const DialogTexts = {
  DIALOG_TITLE_LIVE_MODE: 'Switch to Live mode',
  DIALOG_TITLE_LEARN_MORE: 'About switching environments',
  FIND_YOUR_REPORTS_HERE: 'Find your reports here',
  CONNECTION_FAILED: 'Connection failed. Please try again later.',
  noReports: 'You have no reports yet!',
  ERROR_CHANGE_ORGANIZATION:
    "Oops!... Something went wrong and we couldn't get in. You can try again or come back later.",
  ACCOUNT_CHANGED: 'You have successfully switched accounts.',
  ACCOUNT_NOT_CHANGED: `Couldn't switch accounts. Please try again.`,
  GENERATE_REPORT_AGAIN: 'Please generate the report again for downloading.',
}

export const sections = ({ t }) => {
  return {
    team: { title: t('sections.team'), path: '/users/settings/team' },
    profile: { title: t('sections.profile'), path: '/users' },
    security: {
      title: t('sections.security'),
      path: '/users/settings/security',
    },
    help: { title: t('sections.help'), path: '/users/help' },
    accounts: { title: 'Manage your accounts', path: '/accounts' },
    settings: { title: t('sections.settings'), path: '/users/settings' },
  }
}

export const firebaseTopics = {
  all: 'topics/',
}

export const notificationsType = {
  global: 'GLOBAL',
  reports: 'REPORTS',
}
